(ns cms.editor.storage
  (:require 
    [clojure.string :as str]
    [cemerick.url :as url]
    [cms.asset :as asset]
    [cms.editor.core :refer [resolve-schema
                             schema->enum
                             schema-editor]]
    [cms.fetch :refer [fetch]]
    [common.util :as u]
    [reagent.core :as r]
    [promises.core :refer-macros [await->]]))

(doto js/document 
  (.addEventListener "dragover" #(.preventDefault %))
  (.addEventListener "drop" #(.preventDefault %)))

(defn upload-file [file]
  (await-> 
    (asset/digest-file file)
    
    (then [digest]
          (await-> 
            (fetch 
              (-> (asset/asset-link (str digest))
                  (url/url)
                  (update :query assoc "meta" true)
                  (str)))
            
            (then [response]
                  (println "File already exists" response)
                  { "FileName" (.-name file)
                   "Mime"     (get-in response [:headers "content-type"])
                   "Digest"   digest
                   "Path"     digest })
            
            (catch [err]
              (let [{:keys [status]} (ex-data err)]
                (cond 
                  
                  (= status 404)
                  (do 
                    (println "File not found; uploading")
                    (await-> 
                      (asset/upload-file file)
                      
                      (then 
                        [{:keys [body]}]
                        (println body)
                        (let [{:strs [mime digest path]} 
                              (get body (.-name file))
                              
                              storage
                              {"FileName" (.-name file)
                               "Mime" mime
                               "Digest" digest
                               "Path" path}]
                          storage))))
                  
                  :else 
                  (throw err))))))
    
    (then [response]
          (println "Asset on server " response)
          response)))


(defmethod schema-editor :Storage [url defs schema node&]
  (let [{:strs [FileName Mime Digest Path]} @node&
        
        file-types
        (schema->enum 
          (get-in schema ["properties" "Mime"]))
        
        accepts 
        (when (seq file-types)
          (str/join "," (map (comp #(str "." %) 
                                   asset/mime->extension) 
                             file-types)))
                
        upload! 
        (fn [file dom]                    
          (some-> dom .-classList (.add "uploading"))
          (js/console.log "pending" dom)
          (await-> 
            (upload-file file)
            (then [result] (reset! node& result))
            (catch [err] 
              (js/console.error err)
              (js/alert (str err)))
            (finally 
              (js/console.log "done" dom)
              (some-> dom .-classList (.remove "uploading")))))]
    
    [(fn []
       [:div.storage.column
        {:style {:gap             "4px"}
         
         :on-click 
         (fn [^js e]
           (when (= (.. e -target) (.. e -currentTarget))
             (.. e -currentTarget 
                 (querySelector "input[type=file]")
                 (click))))
         
         :on-drag-enter 
         (fn [^js e]
           (doto e .stopPropagation .preventDefault)
           (.. e -target -classList (add "dragging")))
         
         :on-drag-leave
         (fn [^js e]
           (.. e -target -classList (remove "dragging")))
         
         :on-drag-over 
         (fn [^js e]
           (doto e .stopPropagation .preventDefault))
         
         :on-drop 
         (fn [^js e]
           (doto e .stopPropagation .preventDefault)
           (let [file (aget (.. e -dataTransfer -files) 0)
                 mime (asset/file->mime file nil)]
             (if (some #{mime} file-types)
               (upload! file (.-target e))
               (doto (.-target e)
                 (.. -classList (remove "shake")) 
                 (.-offsetWidth)
                 (.. -classList (add "shake"))))))}
        
        [:input {:type :file
                 :style {:display :none}
                 :accept accepts
                 :on-change 
                 #(upload! 
                    (aget % "target" "files" 0)
                    (.. % -target -parentElement))}]
        
        [:div.spinner]
        
        
        (if-let [{:strs [FileName Path] :as uploaded} @node&]
          [:<>    
           [:details.column
            {:style 
             {:align-items :stretch
              :display :flex
              :width "100%"}}
            
            [:summary [:div {:style {:font-weight :bold}} (str FileName)]]                                  
            
            [:div.asset 
             {:style {:align-items :center
                      :gap "30px"
                      :justify-content :space-between}}
             [:a {:href (asset/asset-link Path)
                  :download FileName
                  :target "_blank"} "⤵️ Download"]
             
             [:div.deemph Mime]
             
             [:button 
              {:on-click 
               (fn [e] 
                 (.. e -target -parentElement
                     (querySelector "input[type=file]"))
                 (reset! node& nil))
               :style {:flex "0 0 2em"}}
              "🗑"]]
            
            (asset/asset-preview uploaded)]]
          
          [:div.upload.deemph {:style {:pointer-events :none}}          
           "Drag a file here or click to browse"])])]))